import { h } from './p-bfa0dc67.js';
import { c as classNames } from './p-df8c8ec2.js';

const messageId = 'message';
/**
 * Accessible validation component that can be used to display a error text for form fields.
 * Remember to add `@import 'path/to/validation.scss';` to the component's SCSS file so the styles are applied.
 */
const Validation = ({ visible, message, dark, noMargin }) => {
    if (!visible)
        return null;
    return (h("span", { id: messageId, class: classNames('validation-message', dark && 'dark', noMargin && 'noMargin'), role: 'alert' }, message));
};

export { Validation as V, messageId as m };
